import NeedHelp from "components/NeedHelp";
import { ClientPopup } from "components/popups/ClientPopup";
import { ConfirmationPopup } from "components/popups/ConfirmationPopup";
//import { DeleteClientPopup } from "components/popups/DeleteClientPopup";
import Button from "components/shared/button";
import Input, { InputType } from "components/shared/inputs/input";
import ListView from "components/shared/list/listView";
import { PaginationToolbar } from "components/shared/list/paginationToolbar";
import { ListViewType, useList } from "components/shared/list/useListHook";
import Loader from "components/shared/loader";
import { Text } from "components/shared/text";
import { usePopup } from "providers/PopupProvider";
import { useState } from "react";
import { useDeleteClientMutation, useGetClientsQuery } from "store/api";
import useCustomForm from "utils/hooks/useCustomForm";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import useTranslation from "utils/hooks/useTranslation";

const ClientItem: React.FC<{ data: Client }> = ({ data }) => {
  const { t } = useTranslation();
  const { isThermor } = useSalesNetwork();
  const { openPopup, closeLastPopup } = usePopup();
  const [deleteClient, { isLoading: isDeleting }] = useDeleteClientMutation();

  return (
    <group
      data-direction="column"
      data-contain=""
      //data-border=""
      {...(isThermor ? {"data-border-color": "main-color-custom-border"} : { "data-border-color": "main-color" })}
      {...(isThermor ? {} : { "data-radius": "extra-special" })}
      //data-color="main"
      data-background="context"
      // data-react="scale"
      data-cursor="pointer"
    >

      <group data-direction="column" data-contain="" data-gap="10" data-space="20" data-height="autofit">
        <Text
          data-text-size="x-large"
          data-weight="700"
          data-color="main"
          data-ellipsis=""
        >
          {data?.data?.name}
        </Text>
        <separator data-horizontal="" data-margin="none"></separator>
        {data?.data?.companyName && <Text data-wrap="wrap" data-clamp="3" data-line="1.5" data-text-size="medium" data-weight="400">
          {data?.data?.companyName}
        </Text>}
        {data?.data?.companyName && <separator data-horizontal="" data-margin="none"></separator>}
        <Text data-wrap="wrap" data-clamp="3" data-line="1.5" data-text-size="medium" data-weight="400">
          {data?.data?.address}
        </Text>
        <separator data-horizontal="" data-margin="none"></separator>
        <Text data-wrap="wrap" data-clamp="3" data-line="1.5" data-text-size="medium" data-weight="400">
          {data?.data?.phone}
        </Text>
      </group>
      <group data-direction="column" data-contain="">
        <separator data-horizontal="" data-margin="none"></separator>
        <group data-gap="5" data-align="center" data-justify="start" >
          <Button 
            material={false} 
            text={t("UPDATE")} 
            large data-color="secondary" 
            data-interactive="" 
            data-transparent="" 
            onClick={() => {
              openPopup(
                <ClientPopup
                  client={data}
                  closePopup={closeLastPopup}
                ></ClientPopup>)
            }} 
          />

          <separator data-vertical=""></separator>
          <Button 
            material={false}
            text={t("DELETE")}
            large
            data-color="secondary"
            data-interactive=""
            data-transparent=""
            onClick={() => {
              openPopup(
                <ConfirmationPopup
                title={t("DELETE_CLIENT")}
                message={"DELETE_WARNING"}
                translateMessage={true}
                icon="warning"
                positiveCallback={() => {
                  deleteClient(data.id as number)
                    
                }}
                negativeCallBack={() => {
                }}
                ></ConfirmationPopup>
              )
              // openPopup(
              //   <DeleteClientPopup
              //     client={data}
              //     closePopup={closeLastPopup}
              //     onDeleted={closeLastPopup}
              //   ></DeleteClientPopup>)
            }}
          />
        </group>
      </group>


    </group>);
};

export const ClientsPage: React.FC = () => {
  const { t } = useTranslation();
  const [search, setSearch] = useState<string>("")
  const { openPopup, closeLastPopup } = usePopup();

  const { pagingProps, resetPagination } = useList({
    viewTypes: [ListViewType.Table],
  });
  const {
    pagination: { current, pageSize }
  } = pagingProps;
  //const [currentPageSize, setCurrentPageSize] = useState<number>(current)

  const {
    handleSubmit,
    control,
  } = useCustomForm<any>({
    defaultValues: {
      q: ""
    },
  });
  // const { data: ClientsData, total, isLoading, isFetching } = useGetClientsQuery({
  const { data: ClientsData, isLoading, isFetching } = useGetClientsQuery({
    pageNumber: current || 1,
    pageSize: pageSize || 10,
    searchInput: search || ""
  });




  return (
    <group>
      <group data-align="center" data-direction="column" data-gap="20">
        <group
          data-gap="40"
          //data-space-vertical="10"
          data-wrap="no"
          data-max-length="1200"
        >
          <group data-direction="column">

            <group data-space="20" data-gap="30" data-wrap="no" data-align="center">
              <form
                data-type="group"
                data-wrap="no"
                onSubmit={handleSubmit((values) => {
                  console.log(values);
                  //onSubmit(values);
                  resetPagination()
                  setSearch(values.q)
                })}
              >
                <Input
                  //{...register("q")}
                  icon={<icon data-space-horizontal="30" data-opacity="30" data-length="" data-icon-size="30">search</icon>}
                  //fit={true}
                  type={InputType.Text}
                  control={control}
                  name="q"
                  //defaultValue={search}
                  button={
                    <Button
                      secondary
                      large
                      //adaptive
                      type="submit"
                      //fit
                      text={t("SEARCH_RE")}
                      onClick={() => {
                        //navigate(getAppUrl('/project/home/heat'))
                        //onSubmit(searchValue);
                      }}
                    />
                  }

                  labelSize={12}
                  //control={control}
                  fixLength="autofit"
                  dataLength="autofit"
                  placeholder={t("CLIENT_SEARCH")}
                />
              </form>
              <separator data-vertical="" data-height="fit"></separator>

              <Button
                data-min-length="240"
                secondary
                large
                fit
                text={t("NEW_CUSTOMER")}
                icon="add"
                onClick={() => {
                  openPopup(
                    <ClientPopup
                      // client={data}
                      closePopup={closeLastPopup}
                    />
                  );
                  //navigate(getAppUrl('/project/home/heat'))
                }}
              />

            </group>
            {isLoading || isFetching ? <Loader /> :
              <>
                <ListView
                  dataSource={(ClientsData as ClientList)?.clients}
                  view={ListViewType.Block}
                  keyField="key"
                  data-name="custom"
                  data-template="260"
                  scrollerProps={{ "data-space": "20" }}
                  listProps={{ "data-gap": "20" }}
                  itemComponent={ClientItem}
                />

                <group
                  data-space="10"
                  data-gap="20"
                  //data
                >
                  <PaginationToolbar
                    data-space="10"
                    data-gap="20"
                    {...pagingProps}
                    total={ClientsData?.total}
                  />
                </group>


              </>
            }

            {/* <Collapse items={items} 
            expandIconPosition={"end"}
                    expandIcon={({ isActive }) => (
                      isActive ? <icon data-svg-size="60" data-svg-color="withe"><SvgArrowUp /></icon> : <icon data-svg-size="60" data-svg-color="withe"><SvgArrowDown /></icon>
                    )}
            /> */}
          </group>
        </group>
      </group>

      <NeedHelp />
    </group>
  );
};
